import { useAppSelector } from "@/shared/lib/redux"
import { selectLatestTransactions, selectTransactionsLoading } from "../../model"
import { DashboardTransactionsTable } from "@/entities/onboarding"

export const TransactionsTable = () => {
    const transactions = useAppSelector(selectLatestTransactions)
    const isLoading = useAppSelector(selectTransactionsLoading)

    return <DashboardTransactionsTable transactions={transactions} isLoading={isLoading} />
}
